/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const storeLocatorSideListAutoCompleteSX: SxProps = {
	width: '100%',
};

export const storeAddressSX: SxProps = {
	color: '#353535',
	cursor: 'pointer',
	fontSize: '18px',
	lineHeight: '25px',
	fontWeight: '400',
	borderBottom: '1px solid #E2E2E2',
	paddingBottom: '10px',
	paddingTop: '15px',
};

export const viewStoresSX: SxProps = {
	color: '#69baf8',
	cursor: 'pointer',
	fontSize: '16px',
	textDecorationLine: 'underline',
	display: 'flex',
	alignItems: 'left',
};

export const cityPageLinkSX: SxProps = {
	textDecoration: 'underline',
	fontWeight: '700',
	fontSize: '16px',
};

export const searchButtonSX: SxProps = {
	bgcolor: '#000',
	color: '#fff',
	textAlign: 'center',
	minWidth: '30%',
	alignContent: 'center',
	justifyContent: 'center',
	borderTopRightRadius: 8,
	borderBottomRightRadius: 8,
};

export const cityPageStoreAddressSX: SxProps = {
	color: '#353535',
	cursor: 'pointer',
	fontSize: '18px',
	lineHeight: '25px',
	fontWeight: '400',
	borderBottom: '1px solid #E2E2E2',
	paddingBottom: '10px',
	paddingTop: '6px',
};
